import React from 'react';
import { Icon } from '../icon/Icon.jsx';
import { Button } from '../controls/Button.jsx';

/* The unit of the Dashboard's attention panel and of every alert surface.
   3px --attn left rule, --bg-surface, NO FILL. Critical items take a --loss rule
   and CANNOT be snoozed. Sorted by severity, then recency. */

export function AttentionCard({ title, detail, severity = 'attention', action, onAction, onSnooze, style }) {
  const critical = severity === 'critical';
  return (
    <article style={{
      display: 'flex', alignItems: 'flex-start', gap: 'var(--space-12)',
      borderLeft: '3px solid ' + (critical ? 'var(--loss)' : 'var(--attn)'),
      background: 'var(--bg-surface)', padding: 'var(--space-12) var(--space-16)', ...style,
    }}>
      <Icon name={critical ? 'octagon-alert' : 'triangle-alert'} size={16}
        style={{ color: critical ? 'var(--loss)' : 'var(--attn)', marginTop: 3 }} />
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
        <div style={{ fontSize: 'var(--body-size)', lineHeight: 'var(--body-line)', fontWeight: 500, color: 'var(--text-primary)' }}>{title}</div>
        {detail ? <div style={{ fontSize: 'var(--caption-size)', lineHeight: 'var(--caption-line)', color: 'var(--text-secondary)' }}>{detail}</div> : null}
      </div>
      <div style={{ display: 'flex', gap: 'var(--space-8)', flex: '0 0 auto' }}>
        {action ? <Button density="compact" onClick={onAction} iconRight="arrow-right">{action}</Button> : null}
        {onSnooze && !critical ? <Button density="compact" variant="ghost" onClick={onSnooze}>Snooze 24h</Button> : null}
      </div>
    </article>
  );
}

/* The panel around them. It KEEPS ITS POSITION when empty, because a panel that
   appears and disappears trains you to distrust the layout. The empty sentence is
   the single most important string in the product. */
export function AttentionPanel({ count, children, empty = 'Nothing needs attention.', style }) {
  const n = count != null ? count : React.Children.count(children);
  return (
    <section aria-live="polite" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-12)', ...style }}>
      <h3 style={{
        margin: 0, fontSize: 'var(--heading-size)', lineHeight: 'var(--heading-line)',
        fontWeight: 'var(--heading-weight)', color: 'var(--text-primary)',
      }}>Attention{n ? ' (' + n + ')' : ''}</h3>
      {n ? <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-8)' }}>{children}</div>
        : <p style={{ margin: 0, fontSize: 'var(--body-size)', lineHeight: 'var(--body-line)', color: 'var(--text-secondary)' }}>{empty}</p>}
    </section>
  );
}
